/* eslint-disable no-undef */

import { getSdk } from '__generated__/api';
import { GraphQLClient } from 'graphql-request';

// We want to eventually load this from config with the current git hash and environment
const CLIENT_INFO = 'shopping-pwa,unknown,unknown';

export const getBexApiSdk = (headers: HeadersInit, url = '/graphql') => {
  const sdkHeaders = { ...headers, 'Client-Info': CLIENT_INFO };
  const options: RequestInit = { headers: new Headers(sdkHeaders), credentials: 'same-origin', cache: 'no-cache' };
  const client = new GraphQLClient(url, options);

  return getSdk(client);
};
